import { render, staticRenderFns } from "./InstructorContent.vue?vue&type=template&id=414f8b12&scoped=true&"
import script from "./InstructorContent.vue?vue&type=script&lang=js&"
export * from "./InstructorContent.vue?vue&type=script&lang=js&"
import style0 from "./InstructorContent.vue?vue&type=style&index=0&id=414f8b12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414f8b12",
  null
  
)

export default component.exports